import { getClassNames } from '@websolutespa/bom-core';
import { useLlm, useLlmView } from '@websolutespa/bom-mixer-llm';
import { ArrowLeftIcon, MenuIcon, Trash2Icon } from 'lucide-react';
import { useState } from 'react';
import { Badge } from '../Badge/badge';
import { History } from '../History/history';
import style from './aside.module.scss';

export const Aside: React.FC = () => {
  const [active, setActive] = useState(false);
  const { clear } = useLlm(state => state.actions);
  const { open } = useLlmView(state => state.actions);
  return (
    <aside className={getClassNames(style.aside, { [style.active]: active })}>
      <div className={style.head}>
        <button className={style.logo} type="button" onClick={() => open()}>
          <Badge variant="sm" /> <span>EFG Chat</span>
        </button>
        <button className={style.menu} type="button" onClick={() => setActive(!active)}>
          <MenuIcon />
        </button>
      </div>
      <div className={style.content}>
        <div className={style.scrollable}>
          <History />
          <div className={style.actionsMobile}>
            <button className={style.button} type="button" onClick={() => clear()}>
              <div className={style.icon}><Trash2Icon /></div>
              <span>Start a new conversation</span>
            </button>
          </div>
        </div>
        <div className={style.actions}>
          <button className={style.button} type="button" onClick={() => clear()}>
            <div className={style.icon}><Trash2Icon /></div>
            <span>Start a new conversation</span>
          </button>
          <button className={style.button} type="button" onClick={() => open()}>
            <div className={style.icon}><ArrowLeftIcon /></div>
            <span>Close</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

